/* eslint-disable @typescript-eslint/no-explicit-any */
export default class Config {
  private envFile: Record<string, any> = {
    development: require("../config/development.ts"),
    production: require("../config/production.ts"),
    staging: require("../config/staging.ts")
  };
  public globals = this.envFile[process.env.NODE_ENV || "development"];
}
